module.exports = __webpack_public_path__ + "img/許力文.0ee24d99.jpg";